// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"223":"8aae4cc8e8756398a625","774":"c7f8e8d7397e9d2c659f","932":"d3754a2f9f9c7d9b01ba"}[chunkId] + ".js";
};